import { render } from "./Dashboard-EIS.vue?vue&type=template&id=0ed7cf5c"
import script from "./Dashboard-EIS.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS.vue?vue&type=script&lang=js"

import "./Dashboard-EIS.vue?vue&type=style&index=0&id=0ed7cf5c&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__